'use strict';

function updateKlarnaPayments() {
	$.ajax({
		url: Urls.updateKlarnaPayments
	}).done(function (response) {
		$('#klarna-payment-method-info').html(response);
		window.klarnaAsyncCallback();
	});
}

var kf = {
	updateKlarnaPayments: updateKlarnaPayments
};

module.exports = kf;
